export const RESERVATIONS_BASE_KEY = 'reservations';
